var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.305,
    height: 12.208,
    viewBox: "0 0 45.305 12.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.368 1.368)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.512,
    transform: "translate(0.215 9.472)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.543,
    y2: 9.472,
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.543,
    y1: 9.472,
    transform: "translate(5.543)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.928,
    y2: 9.472,
    transform: "translate(11.086)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.928,
    y1: 9.472,
    transform: "translate(15.015)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: 9.472,
    x2: 3.928,
    transform: "translate(18.943)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 4.359,
    transform: "translate(23.087)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 4.284,
    transform: "translate(23.162 9.472)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,441.5s3.206-.311,3.164,5.145",
    transform: "translate(-1934.054 -441.495)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,445.815s3.206.261,3.164-4.321",
    transform: "translate(-1934.054 -436.346)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,443.862s1.946.143,1.92-2.368",
    transform: "translate(-1920.485 -434.392)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,441.5s1.946-.143,1.92,2.368",
    transform: "translate(-1920.485 -441.495)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: "0 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1963.422,443.862s-1.946.143-1.921-2.368",
    transform: "translate(-1927.312 -434.392)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: "0 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1963.422,441.5s-1.946-.143-1.921,2.368",
    transform: "translate(-1927.312 -441.495)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,441.5s1.946-.143,1.92,2.368",
    transform: "translate(-1920.485 -436.746)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1963.422,443.862s-1.946.143-1.921-2.368",
    transform: "translate(-1927.318 -439.121)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.247,
    transform: "translate(35.877 9.472)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.247,
    transform: "translate(35.877)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 4.909,
    transform: "translate(36.103 4.756)",
    fill: "none",
    stroke: "#888",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/Footer_Logo.cecbce8458face76888e912ac6135bae.svg";
export { ForwardRef as ReactComponent };